module.exports = __webpack_public_path__ + "static/media/The End.18149bb3.jpg";